import searchImg from "@assets/header/search.svg";
import searchDark from "@assets/header/search-dark.svg";
import Button from "@components/Button/Button";
import Link from "@components/Link";
import { ThemeEnum } from "@components/ThemeProvider/ThemeProvider";
import SocialShare from "@src/app/components/SocialShare/SocialShare";
import clsx from "clsx";
import type { ReactElement } from "react";
import { useState } from "react";

interface HeaderActionsProps {
  theme: ThemeEnum;
  isHeaderSticky: boolean;
  showShare: boolean;
  isScrolled: boolean;
  isSmallScreen: boolean;
  onSearchClick: () => void;
}

export default function HeaderActions({
  theme,
  isHeaderSticky,
  showShare,
  isScrolled,
  isSmallScreen,
  onSearchClick,
}: HeaderActionsProps): ReactElement {
  const [hovered, setHovered] = useState(false);

  return (
    <>
      <div
        className={clsx(
          "flex h-[58px] flex-1 items-center justify-end py-[8px] lg:h-[100px] lg:py-0",
          "transition-[height] duration-200 ease-out",
          showShare && "transition-opacity duration-300",
          showShare && isScrolled && "max-lg:hidden",
          isHeaderSticky && !isSmallScreen && "!h-[48px]",
        )}
      >
        {/* 搜索按钮 */}
        <button
          className="mr-[12px] box-content size-[24px] rounded-full p-[8px] lg:mr-[20px] lg:hover:bg-button-ghost"
          onClick={onSearchClick}
          onMouseEnter={() => {
            setHovered(true);
          }}
          onMouseLeave={() => {
            setHovered(false);
          }}
        >
          <img
            src={
              theme === ThemeEnum.dark
                ? hovered
                  ? searchImg
                  : searchDark
                : searchImg
            }
            alt="search"
            className="size-[24px]"
          />
        </button>

        {/* 投稿按钮 */}
        <Button
          size="large"
          className={clsx(
            "box-border flex items-center justify-center text-button-1 text-button-primary-label max-lg:h-[32px] max-lg:w-[56px] max-lg:!px-[12px] lg:h-[40px] lg:w-[64px]",
            isHeaderSticky && "lg:!h-[32px] lg:!px-[12px]",
          )}
        >
          <Link className="whitespace-nowrap" to="/submission?ref=header">
            投稿
          </Link>
        </Button>
      </div>

      {/* 移动端社交分享 */}
      {showShare && isScrolled && isSmallScreen && (
        <SocialShare
          iconOnly
          className="mr-[4px] !flex-row-reverse !gap-[16px] transition-opacity duration-300"
          copyLinkMessagePosition="left"
        />
      )}
    </>
  );
}
